'use client'

import { useEffect } from 'react'

import { setProductClasses } from './product-class-store'

// Invisible page marker: pages that show hearing aids render this (a product
// page one class, a compare page both sides) so the popup controller knows
// which product classes are on screen — prescription vs OTC vs hearable isn't
// derivable from the URL. Clears itself on unmount (soft-nav away).
export const RegisterProductClasses = ({ productClasses }: { productClasses: string[] }) => {
  // Serialize the deps so a fresh array literal on every render doesn't re-run
  // the effect.
  const key = productClasses.join('|')
  useEffect(() => {
    setProductClasses(key === '' ? [] : key.split('|'))
    return () => setProductClasses([])
  }, [key])
  return null
}
